import { useState, useEffect } from 'react';
export default function useWindowSize() {
    var isClient = typeof window === 'object'; // 클라이언트 사이드에서만 해당 훅을 사용
    var _a = useState({
        width: isClient ? window.innerWidth : 0,
        height: isClient ? window.innerHeight : 0,
    }), windowSize = _a[0], setWindowSize = _a[1];
    useEffect(function () {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [isClient]);
    return windowSize;
}
//# sourceMappingURL=useWindowSize.js.map